module.exports = __webpack_public_path__ + "img/part-2-info-2.1ce1b11f.png";